import { gql } from "@apollo/client";

// CTO todo copy in create
export const CREATE_FEED_CURVE = gql`
  mutation CreateFeedCurve($domain: String!, $name: String!) {
    createFeedCurve(domain: $domain, name: $name) {
      code
      success
      message
      updatedValues {
        feedcurve_id
        name
      }
    }
  }
`;


export interface CreateFeedCurveResponse {
  createFeedCurve: CreateFeedCurve 
}

interface CreateFeedCurve {
    code: String
    success: Boolean
    message: string
    updatedValues: CreateFeedCurveUpdatedValues[]
  }

interface CreateFeedCurveUpdatedValues {
  feedcurve_id: number,
  name: string
}